var r=function(r){return""===r?{}:"_blank"===r?{target:r,rel:"noopener noreferrer"}:{target:r}};export{r as getTarget};
